module.exports = __webpack_public_path__ + "static/assets/f2fcad75be66a1398821aeb251c09cab.svg";